// This file contains enums representing each Optimizely feature flag used by this webapp.

/**
 * Whether the partner block's cards may draw the product's other photographs.
 *
 * `SINGLE` is the default and the control: the card is handed the hero alone, so it draws a
 * plain frame with no dots, no swipe and no hover reveal. `MULTIPLE` is the gallery.
 *
 * Defaulted off rather than on because `plp_product_card_image` (DISC-4591) is measuring this
 * same gallery on the PLP grid. Turning it on here first would answer that question with this
 * surface's traffic before the experiment has read out. Delete this flag and take the winning
 * arm once it has.
 *
 * The product carousel has no equivalent flag: `ProductCarousel` forces one image per product
 * whatever it is handed, so there is no second arm to offer.
 *
 * Turning this on changes nothing today, and that is a property of the data rather than of the
 * wiring. UPS answers with one image per product where listings-api answers with up to five for
 * the same product: on QA, six products picked from a listings response carrying three to five
 * images each came back from `productsByIds` with exactly one, as did all eighty product codes
 * these pages actually reference. So check UPS carries the other photographs before running an
 * experiment on this, or it will measure two identical arms.
 */
export enum PartnerBlockImages {
  MULTIPLE = 'multiple',
  NAME = 'cmspages_partner_block_images',
  SINGLE = 'single',
}
